import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { PhameeService } from 'src/app/services/phamee.service';
import { UserService } from 'src/app/services/user-service.service';
import { environment } from '../../../environments/environment';
import * as uuid from 'uuid';
@Component({
  selector: 'smart-preload',
  templateUrl: './preload.component.html',
  styleUrls: ['./preload.component.scss']
})
export class PreloadComponent implements OnInit {
  code: string = "";
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private userService: UserService,
    private PhameeService: PhameeService,
  ) {
  }
  
  async ngOnInit() {
    this.code = this.route.snapshot.queryParams["code"];
    this.clearStorage();

    if (this.code) {
      this.authService.getPlatformInfo(this.code)
        .subscribe(async (success) => {

          if (success.code == 200) {
            this.setRole(success.data);
 
          } else {
            sessionStorage.clear();
            window.location.href = `${environment.GATEWAY_URL}/error-page?errorCode=03`
          }
        });
    }else{
      window.location.href = `${environment.GATEWAY_URL}/error-page?errorCode=03`
    }
  }

  checkRole(data){
    this.userService.checkRole().subscribe(async (roleresponse) => {

      if(roleresponse.code == 200){

        this.userService.getUserByUsername()
        .subscribe(response => {

          if (response.code == 200) {
            this.setOrgConfig(response.data);
            this.getMenu(data.child_org_id);
          }
        });
      }else{
        window.location.href = `${environment.GATEWAY_URL}/error-page?errorCode=03`
      }
    });    
  }

  setRole(data){
    let role = "";
    if(data.role == 'global_admin' || data.role == 'super_admin' || data.role == 'admin_child'){
      role = 'admin';
    }else{
      role = 'user';
    }
    
    sessionStorage.setItem('access_token', data.access_token);
    sessionStorage.setItem('refresh_token', data.refresh_token);
    sessionStorage.setItem('system_role', data.role);

    if (role.includes("user")){
      this.PhameeService.getDropdownDashboard().subscribe(async (success) => {
        if (success.code == 200) {

          this.PhameeService.getPlotDashboard(success.data.FarmList[0].id).subscribe((success) => {
  
            if (success.code == 200) {
              sessionStorage.setItem("role", success.data.role);
            }else{
              sessionStorage.setItem('role', role);
            }
            this.checkRole(data);
          });
        }else{
          sessionStorage.setItem('role', role);
          this.checkRole(data);
        }
      });
    }else{
      sessionStorage.setItem('role', role);
      this.checkRole(data);
    }
  }

  setOrgConfig(data){
    sessionStorage.setItem('display_name', `${data.first_name} ${data.last_name}`)
    sessionStorage.setItem('username', data.username)
    sessionStorage.setItem('profile_img', data.profile_img)
    sessionStorage.setItem('template', data.orgConfig ? data.orgConfig.template : null)
    sessionStorage.setItem('logo_large', data.orgConfig ? data.orgConfig.logo.large : null)
    sessionStorage.setItem('logo_small', data.orgConfig ? data.orgConfig.logo.small : null)
    sessionStorage.setItem('styles', JSON.stringify(data.orgConfig.styles));
    sessionStorage.setItem('package', JSON.stringify(data.orgConfig.package));
    // sessionStorage.setItem('transactionid', uuid.v4());
  }

  clearStorage(){
    sessionStorage.clear();
  }

  getMenu(chilorgId) {
    this.PhameeService.getPlotMenu(chilorgId)
      .subscribe(response => {
        let arrMenu = [];
        if (response.code == 200) {
          arrMenu = response.data; 

          sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));
          this.router.navigate(["/dashboard"]).then(() => {
            window.location.reload();
          });
        }else{
          sessionStorage.clear();
          window.location.href = `${environment.GATEWAY_URL}/error-page?errorCode=03`
        }
      });
  }
}
